(function ($) {
  'use strict';

  /**
   * Dynamic show/hide question behaviour
   */
  function ConditionalQuestions () {
  }

  ConditionalQuestions.prototype = {

    init: function () {
      var self = this;
      var $els = $('[data-show-if]');

      $els.each($.proxy(this.showHideQuestion, this));

      // trigger show/hide on interaction on selects
      $('select').on('change input', function (e) {
        $els.each($.proxy(self.showHideQuestion, self));
      });

      // trigger show/hide on interaction
      $('input').on('click', function (e) {
        $els.each($.proxy(self.showHideQuestion, self));
      });
    },

    /*
     * Test multiple show if conditions
     *
     * @param conditionString {string}
     * @param el {object} The show-if element
     *
     * @return bool
     */
    testAllConditions: function (conditionString, $el) {
      // Now split the condition string on '||' to get individual 'OR'
      // conditions
      var subConditionStrings = conditionString.split('||');

      // Loop through all the 'OR' conditions - as long as at least one is true,
      // return true
      for (var i = 0; i < subConditionStrings.length; i++) {
        if (this.testSingleCondition(subConditionStrings[i], $el)) {
          return true;
        }
      }
      return false;
    },

    /*
     * Test single show if condition (may contain AND clauses)
     *
     * @param conditionString {string}
     * @param el {object} The show-if element
     *
     * @return bool
     */
    testSingleCondition: function (conditionString, $el) {
      // Trim and then split each condition on '&&' to get individual 'AND'
      // conditions
      var conditions = $.trim(conditionString).split('&&');
      var conditionArray;
      var conditionQuestionSlug;
      var conditionValue;
      var conditionFieldValues;

      // Loop through all 'AND' conditions
      for (var i = 0; i < conditions.length; i++) {
        // Check '==' conditions
        if (conditions[i].indexOf('==') !== -1) {
          conditionArray = conditions[i].split('==');
          conditionQuestionSlug = '"' + $.trim(conditionArray[0]) + '"';
          conditionValue = $.trim(conditionArray[1]);
          conditionFieldValues = this.getConditionFieldValues(conditionQuestionSlug, $el);

          // If any of the EQUAL TO conditions is not met, return false
          if (conditionFieldValues.indexOf(conditionValue) === -1) {
            return false;
          }
        } else if (conditions[i].indexOf('!=') !== -1) {
          conditionArray = conditions[i].split('!=');
          conditionQuestionSlug = '"' + $.trim(conditionArray[0]) + '"';
          conditionValue = $.trim(conditionArray[1]);
          conditionFieldValues = this.getConditionFieldValues(conditionQuestionSlug, $el);

          // If any of the NOT EQUAL TO conditions is met, return false
          if (conditionFieldValues.indexOf(conditionValue) !== -1) {
            return false;
          }
        }
      }
      return true;
    },

    /*
     * Get the value(s) of a specific field
     *
     * @param condition {string} The text of the condition
     *
     * @return bool
     */
    getConditionFieldValues: function (conditionQuestionSlug, $el) {
      // Only get those fields that are enabled OR are a hidden answer from a previous page
      var conditionFieldSelector = ':input[name=' + conditionQuestionSlug + ']:enabled, .js-hidden-question[name=' + conditionQuestionSlug + ']';
      var conditionFieldSelectorRadio = 'input:radio[name=' + conditionQuestionSlug + ']:enabled:checked';
      var conditionFieldSelectorCheckbox = 'input:checkbox[name=' + conditionQuestionSlug + ']:enabled:checked';

      // Initialise an empty array of field values
      var conditionFieldValues = [];

      // Get the target field
      var $conditionField = $(conditionFieldSelector);

      if ($conditionField.length === 0) {
        // If the target field is not on this page,
        // there's no way we can use JS to show/hide it
        return conditionFieldValues;
      } else {
        // Remove the existing u-hidden class,
        // because show/hide will now be managed with JS
        $el.removeClass('u-hidden');
      }

      // Switch on the field type
      // Is this a select?
      if ($conditionField.is('select')) {
        var conditionFieldValue = $conditionField.find(':selected').val();
        // If the condition is based on a unselected select input
        if (conditionFieldValue === '') {
          conditionFieldValues.push('__UNSELECTED');
        } else {
          conditionFieldValues.push(conditionFieldValue);
        }
      } else if ($conditionField.is(':radio')) {
        // Is this a radio?
        conditionFieldValues.push($(conditionFieldSelectorRadio).val());
      } else if ($conditionField.is(':checkbox')) {
        // Is this a set of checkboxes?
        $(conditionFieldSelectorCheckbox).each(function () {
          conditionFieldValues.push($(this).val());
        });
      } else {
        // This must be a text field
        conditionFieldValues.push($conditionField.val());
      }

      return conditionFieldValues;
    },

    /*
     * show/hide each question
     *
     * @param counter {int}
     * @param el {object} The show-if element
     */
    showHideQuestion: function (counter, el) {
      var $el = $(el);
      var conditionString = $el.data('show-if');

      // Has at least one condition been met?
      if (this.testAllConditions(conditionString, $el)) {
        // We're only concerned with elements that are NOT currently visible
        if (!$el.is(':visible')) {
          // If this element has been hidden with js remove this class and enable it
          if ($el.hasClass('u-js-hide')) {
            $el.removeClass('u-js-hide');
            $el.find('input, select, textarea').prop('disabled', false);
            // If this element has been hidden based on saved answers,
            // only show it if the prerequisite question is on this page
          } else if ($el.hasClass('u-hidden')) {

          }

          // Find radio inputs
          var $defaultRadioOption = $el.find('.input[data-default="true"]');
          // Check the default radio options for both types of input
          $defaultRadioOption.find('input').prop('checked', true);
        } else {
          // Check if there is a 'N/A' checkbox for this question
          var $naCheckbox = $el.find('input[id$="na"]');
          // If there isn't, or it's unchecked…
          if ($naCheckbox.length < 1 || !$naCheckbox.is(':checked')) {
            // Just remove the disabled attribute,
            // which it may have wrongly been given due to previous answers
            $el.find('input, select, textarea').prop('disabled', false);
          }
        }

        return;
      }

      // If we got here the condition has NOT been met
      // If the element is currently visible we need to hide it
      // Once it is hidden we need to perform some DOM cleaning
      if ($el.is(':visible') || $el.data('type') === 'page') {
        // Close the element
        $el.addClass('u-js-hide');
        $el.find('input, select, textarea').prop('disabled', true);

        // Empty all fields within it
        $el.find('input:text, input[type="number"], textarea').val('');
        $el.find('input:radio, input:checkbox').prop('checked', false);
        $el.find('select').prop('selectedIndex', 0);
        $el.find('label').removeClass('selected'); // Remove selected class from faux form elements
      }
    }
  };

  this.ConditionalQuestions = ConditionalQuestions;
}).call(Framework, jQuery);
